<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Informações</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content pt-60 bottom-sp60">

            <div class="container hidden-xs hidden-md">
                <h2>Informações gerenciais</h2>
            </div>


            <div class="container">
                <div class="row">
                    <div class="col-33">
                        <button class="button " v-bind:class="{'button-fill': form.periodo == 'diario', 'button-outline': form.periodo != 'diario'}" v-on:click="setFiltro('diario')">
                            Diário
                        </button>
                    </div>
                    <div class="col-33">
                        <button class="button " v-bind:class="{'button-fill': form.periodo == 'semanal', 'button-outline': form.periodo != 'semanal'}" v-on:click="setFiltro('semanal')">
                            Semanal
                        </button>
                    </div>
                    <div class="col-33">
                        <button class="button " v-bind:class="{'button-fill': form.periodo == 'mensal', 'button-outline': form.periodo != 'mensal'}" v-on:click="setFiltro('mensal')">
                            Mensal
                        </button>
                    </div>                    
                </div>
            </div>

            
            <div class="container pt-30 pb-15" v-if="data">
                <div class="title-bar pb-10">
                    <h5 class="dz-title">
                        Visão geral
                    </h5>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Faturamento no período</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>R$ {{data.faturamento  | toMoney }}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Número de horários comprados</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.comprados}}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Número de horários cancelados</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.cancelados}}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Número de procedimentos realizados</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.procedimentos}}</strong></div>
                </div>                
                <div class="rewards-card">
                    <h6 class="title">Buscas por profissionais da área</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.buscasArea}}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Número de visitas ao perfil</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.visitas}}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Conversões de visitas em agendamentos</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{data.conversoesVisitas}} %</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Taxa de saque para conta bancária</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>R$ {{$root.config.configuracoes.taxaSaque | toMoney}}</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Taxa de serviço do aplicativo (consultas)</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{$root.config.configuracoes.taxaConsulta}}%</strong></div>
                </div>
                <div class="rewards-card">
                    <h6 class="title">Taxa de serviço do aplicativo (procedimentos)</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{$root.config.configuracoes.taxaProcedimento}}%</strong></div>
                </div>                
                <div class="rewards-card">
                    <h6 class="title">Tempo de recebimento com cartão de crédito</h6>
                    <div class="badge-lg colot-theme-yellow"><strong>{{$root.config.configuracoes.tempoCartao}} dia(s)</strong></div>
                </div>                                        
            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Informacoes',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
            // return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "data":                 false,
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "periodo":          "diario"
            }              
        }
    },
    methods: {
        setFiltro: function(periodo) {
            var self = this;
            self.form.periodo = periodo;
            self.$forceUpdate();
            self.get(true);
        },
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            if (e) loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/metricas.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    if (e) loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    // self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
    },
    activated: function() {
        var self = this;

        Promise.all([
            self.$root.getConfig(),
            self.get()
        ]).then(function() {
            
            loading.hide();

        }).catch(function(error) {
            loading.hide();
        });        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Informacoes.vue